<template>
  <div class="card has-margin-top-30-mobile">
    <header class="card-header">
      <div
        class="column is-12 has-padding-left-30-desktop has-padding-right-30-desktop"
      >
        <div class="columns is-mobile is-vcentered is-desktop">
          <div class="column is-11">
            <div class="has-text-weight-bold is-size-6">
              {{
                $auth.user.has_free_post_balance
                  ? $t('Confirm your job post')
                  : $t('Job Post Display Options')
              }}
            </div>
            <div class="is-size-7 has-text-grey">
              {{ $t('Confirm job post with following parameters') }}
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="section card-content py-6 is-full-height">
      <div class="is-multiline is-vcentered is-mobile">
        <div class="control">
          <div class="tabs is-boxed overflow-hidden">
            <ul>
              <li
                v-for="(tab, index) in servicePurchases"
                :key="`homepage-tabs-${index}`"
                class="is-full-width is-full-height"
                :class="{
                  'is-active': selected_service.name === tab.name
                }"
              >
                <a
                  @click="selectService(tab.id, tab.name)"
                  class="is-full-width is-full-height py-1"
                >
                  <span
                    v-if="$auth.user.has_free_post_balance"
                    class="text-capitalize"
                  >
                    {{ $t('Bonus Job') }}
                  </span>
                  <span v-else class="text-capitalize is-size-7">{{
                    $t(tab.name)
                  }}</span>
                  <span
                    v-if="selected_service.name === tab.name"
                    class="pl-2 pt-1"
                  >
                    <vue-icon-base
                      height="16"
                      width="16"
                      :path="$options.icons[$kc('uni-tick')]"
                      color="green"
                    >
                    </vue-icon-base>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <div v-for="tab in services" :key="tab.id">
          <div v-show="selected_service.name === tab.name">
            <div
              v-if="selected_service.available == 0"
              class="py-5 is-size-3 has-text-weight-bold"
            >
              Rs.
              {{ Intl.NumberFormat('en-IN').format(tab.discounted_base_price)
              }}<span class="is-size-6 unit-color">/unit</span>
            </div>
            <div
              v-if="
                selected_service.available !== 0 &&
                !$auth.user.has_free_post_balance
              "
              class="py-5 is-size-4 has-text-weight-bold"
            >
              <span class="is-size-5 unit-color">Available Balance:</span>
              {{
                Intl.NumberFormat('en-IN').format(selected_service.available)
              }}
            </div>
            <hr class="mt-0 mb-3" />
            <div class="columns is-flex pl-5">
              <div class="column is-9 is-9-mobile is-size-7">
                <ul class="bullet-point">
                  <li>{{ $t('Job Post Validity') }}</li>
                </ul>
              </div>
              <div class="column is-size-7 is-3 px-0">
                <span>
                  {{ tab.deadline_settings[0].days }} {{ $t('days') }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div v-if="selected_service.detail != null">
          <div
            v-for="(value, key, index) in selected_service.detail"
            :key="index"
            class="pt-3"
          >
            <div class="columns is-flex pl-5">
              <div class="column is-9 is-9-mobile is-size-7">
                <ul class="is-flex bullet-point">
                  <li>{{ $t(key) }}</li>
                </ul>
              </div>
              <div class="column is-size-7 is-3 px-0">
                <span v-if="typeof value === 'boolean'">
                  <vue-icon-base
                    height="16"
                    width="16"
                    :path="$options.icons[$kc('uni-tick')]"
                    color="green"
                  >
                  </vue-icon-base>
                </span>
                <span v-else>
                  {{ $t(value) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer pa-2 is-12">
      <button
        :class="loading ? 'is-loading' : ''"
        :disabled="disabled"
        class="button is-employer is-fullwidth"
        @click="publishJob()"
        v-text="
          selected_service.available == 0
            ? $t('Proceed to Payment')
            : $t('Request to Publish')
        "
      ></button>
    </div>
  </div>
</template>
<script>
import VueIconBase from '@/components/Commons/VueIconBase'
import { uniTick } from '@/helpers/icons'
import {
  basicjobDetail,
  standardjobDetail,
  premiumjobDetail
} from '@/helpers/constants/pricing'
export default {
  basicjobDetail,
  standardjobDetail,
  premiumjobDetail,
  icons: {
    uniTick
  },
  components: {
    VueIconBase
  },
  props: {
    jobPost: {
      type: Boolean,
      default: false
    },
    jobdetail: {
      type: Object
    }
  },
  data() {
    return {
      disabled: false,
      services: [],
      total_price: 0,
      selected_service: {},
      purchases: {},
      loading: false,
      packagesDetails: {
        'Basic Job': basicjobDetail,
        'Standard Job': standardjobDetail,
        'Premium Job': premiumjobDetail
      },
      job: false,
      servicePurchases: []
    }
  },
  watch: {
    selected_service: {
      handler(val) {
        if (this.purchases) {
          this.selected_service.available = this.purchases[val.name]
        }
      },
      deep: true
    }
  },
  mounted() {
    this.fetchServices()
  },
  methods: {
    selectService(id, name) {
      this.selected_service = {
        id,
        name,
        detail: this.packagesDetails[name],
        available: this.purchases[name]
      }
    },
    fetchServices() {
      this.$axios.$get(`/api/v1/service/job-post-pricing/`).then(response => {
        /* In case of free job post, the package with least discounted base price
          is choosen automatically.
        */
        if (this.$auth.user.has_free_post_balance) {
          const freePackage = response.results
            .sort(
              (current, next) =>
                next.discounted_base_price - current.discounted_base_price
            )
            .pop()
          this.services.push(freePackage)
          this.selected_service = {
            id: freePackage.id,
            name: freePackage.name,
            detail: this.packagesDetails[freePackage.name],
            available: 0
          }
        } else {
          this.services = response.results
          if (this.$auth.user.is_purchase_available) {
            this.fetchPackages()
          } else {
            this.selected_service = {
              id: this.services[1].id,
              name: this.services[1].name,
              detail: this.packagesDetails[this.services[1].name],
              available: 0
            }
          }
        }
      })
    },
    fetchPackages() {
      this.$axios
        .$get(`/api/v1/service/job-post-pricing/purchase/`)
        .then(response => {
          this.purchases = response
          this.services.forEach(service => {
            if (this.purchases[service.name] !== 0) {
              this.selected_service = {
                id: service.id,
                name: service.name,
                detail: this.packagesDetails[service.name],
                available: this.purchases[service.name]
              }
              this.servicePurchases.push(service)
            }
          })
        })
    },
    publishJob() {
      this.$nuxt.$emit('disableJobPost')
      if (this.selected_service != null) {
        const jobId = parseInt(localStorage.getItem('jobId'))
        if (this.jobdetail.id === jobId) {
          this.notifyError(this.$t('This job has already been posted.'))
        } else {
          this.disabled = true
          localStorage.setItem('jobId', this.jobdetail.id)
          const endpoint = `/api/v1/job/${this.$route.query.slug}/service-step/`
          if (
            this.selected_service.available !== 0 &&
            !this.$auth.user.has_free_post_balance
          ) {
            this.$axios
              .$put(endpoint, { purchase: this.selected_service.id })
              .then(response => {
                this.useAvailableBalance()
              })
          } else {
            this.$axios
              .$put(endpoint, {
                package: this.selected_service.id,
                is_first_job_post: this.$auth.user.has_free_post_balance
              })
              .then(response => {
                this.postInCart(response)
              })
              .catch(error => {
                if (error.response.data.package) {
                  this.notifyError(error.response.data.package[0])
                }
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      } else {
        this.notifyError('Please Select Job Service')
      }
    },
    useAvailableBalance() {
      const endpoint = `/api/v1/job/${this.$route.query.slug}/job-publish/`
      this.$axios
        .$post(endpoint, { job: this.$route.query.slug })
        .then(() => {
          const errorMessage = this.jobdetail
            ? this.$t('Successfully sent request.')
            : this.$t('Error occurred during the process')
          this.notifyUser(errorMessage)
          this.$router.push(
            this.localePath({
              name: 'employer-profile-id',
              params: { id: 'me' },
              query: { tab: 'pending-jobs' }
            })
          )
          this.$nuxt.$emit('enableJobPost')
        })
        .finally(() => {
          this.loading = false
          this.$auth.fetchUser()
        })
    },
    postInCart(response) {
      const endpoint = `api/v1/payment/wishlist-item/`
      const postData = {
        package: response.id || '',
        quantity: 1,
        wished: true
      }
      this.$axios.$post(endpoint, postData).then(() => {
        if (this.$auth.user.has_free_post_balance) {
          const offlinePublishEndpoint = '/api/v1/payment/offline-gateway/'
          this.$axios
            .$post(offlinePublishEndpoint, {
              job: this.$route.query.slug
            })
            .then(() => {
              this.notifyUser(this.$t('Thank you for free job post.'))
            })
            .catch(error => {
              this.notifyError(error.response.data.error)
            })
            .finally(() => {
              this.loading = false
              this.$auth.fetchUser()
              this.$router.push(
                this.localePath({
                  name: 'employer-profile-id',
                  params: { id: 'me' },
                  query: { tab: 'pending-jobs' }
                })
              )
              this.$nuxt.$emit('enableJobPost')
            })
        }
        if (!this.$auth.user.has_free_post_balance) {
          this.$router.push(
            this.localePath({
              name: 'payment-cart-summary'
            })
          )
        }
      })
    }
  }
}
</script>
<style scoped>
.tabs li.is-active a {
  color: #e49228;
}
.bullet-point {
  list-style-type: disc;
}
.unit-color {
  color: #999393;
}
</style>
